import ControlKit from '@brunoimbrizi/controlkit';
import Stats from 'stats.js';
import * as THREE from 'three';

import { PARTICLES_CONFIG } from "../../const";

export default class GUIView {

	constructor(app) {
		this.app = app;

		this.particlesHitArea = false;
		this.particlesRandom = PARTICLES_CONFIG.uRandom.min;
		this.particlesCurl = PARTICLES_CONFIG.uCurl.min;
    this.particlesContrast = 1.;
		this.particlesScale = 1.;
		this.particlesDepth = PARTICLES_CONFIG.uDepth.min;
		this.particlesSize = PARTICLES_CONFIG.uSize.min;

		this.color = '#ffffff';

    this.textureGrayscaleR = 0.28;
    this.textureGrayscaleG = 0.02;
    this.textureGrayscaleB = 0.28;

		this.touchRadius = 0.15;

		this.range = [0, 1];
		this.grayscaleR = [0, 1];
		this.grayscaleG = [0, 1];
		this.grayscaleB = [0, 1];
		this.rangeRandom = [1, 50];
		this.rangeSize = [0, 3];
    this.rangeContrast= [0, 4];
		this.rangeDepth = [1, 50];
		this.rangeRadius = [0, 0.5];
		this.rangeCurl = [0, 10];
		this.rangeScale = [0, 2];

		this.initControlKit();
	}

	initControlKit() {
		this.controlKit = new ControlKit();
		this.controlKit.addPanel({ width: 300, enable: false })

		// .addGroup({label: 'Touch', enable: true })
		// .addCanvas({ label: 'trail', height: 64 })
		// .addSlider(this, 'touchRadius', 'rangeRadius', { label: 'radius', onChange: this.onTouchChange.bind(this) })

		.addGroup({label: 'Particles', enable: true })
		.addSlider(this, 'particlesRandom', 'rangeRandom', { label: 'random', onChange: this.onParticlesChange.bind(this) })
		.addSlider(this, 'particlesCurl', 'rangeCurl', { label: 'curl', onChange: this.onParticlesChange.bind(this) })
    .addSlider(this, 'particlesScale', 'rangeScale', { label: 'scale', onChange: this.onParticlesChange.bind(this) })
		.addSlider(this, 'particlesDepth', 'rangeDepth', { label: 'depth', onChange: this.onParticlesChange.bind(this) })
		.addSlider(this, 'particlesSize', 'rangeSize', { label: 'size', onChange: this.onParticlesChange.bind(this) })
    .addSlider(this, 'particlesContrast', 'rangeContrast', { label: 'contrast', onChange: this.onParticlesChange.bind(this) })

    .addGroup({label: 'Texture grayscale', enable: true })
    .addSlider(this, 'textureGrayscaleR', 'grayscaleR', { label: 'R', onChange: this.onParticlesChange.bind(this) })
    .addSlider(this, 'textureGrayscaleG', 'grayscaleR', { label: 'G', onChange: this.onParticlesChange.bind(this) })
    .addSlider(this, 'textureGrayscaleB', 'grayscaleR', { label: 'B', onChange: this.onParticlesChange.bind(this) })

    .addGroup({label: 'Texture color', enable: true })
    .addColor(this, 'color', { label: 'Color', onChange: this.onParticlesChange.bind(this) })
	}

	initStats() {
		this.stats = new Stats();
		document.body.appendChild(this.stats.dom);
	}

  updateAll() {
    this.onParticlesChange();
  }

	enable() {
		this.controlKit.enable();
		if (this.stats) this.stats.dom.style.display = '';
	}

	disable() {
		this.controlKit.disable();
		if (this.stats) this.stats.dom.style.display = 'none';
	}

	toggle() {
		if (this.controlKit._enabled) this.disable();
		else this.enable();
	}

	onTouchChange() {
		if (!this.app.webgl) return;
		if (!this.app.webgl.particles) return;

		this.app.webgl.particles.touch.radius = this.touchRadius;
	}

	onParticlesChange() {
		if (!this.app.webgl) return;
		if (!this.app.webgl.particles) return;

    if (!this.app.webgl.particles.object3D) return;

		this.app.webgl.particles.object3D.material.uniforms.uRandom.value = this.particlesRandom;
		this.app.webgl.particles.object3D.material.uniforms.uCurl.value = this.particlesCurl;
    this.app.webgl.particles.object3D.material.uniforms.uContrast.value = this.particlesContrast;
    this.app.webgl.particles.object3D.material.uniforms.uScale.value = this.particlesScale;
		this.app.webgl.particles.object3D.material.uniforms.uDepth.value = this.particlesDepth;
		this.app.webgl.particles.object3D.material.uniforms.uSize.value = this.particlesSize;

		// this.app.webgl.particles.object3D.material.uniforms.grayscaleR.value = this.textureGrayscaleR;
		// this.app.webgl.particles.object3D.material.uniforms.grayscaleG.value = this.textureGrayscaleG;
		// this.app.webgl.particles.object3D.material.uniforms.grayscaleB.value = this.textureGrayscaleB;

		this.app.webgl.particles.object3D.material.uniforms.uColor.value = new THREE.Color(this.color);
	}

	onPostProcessingChange() {
		if (!this.app.webgl.composer) return;
		this.app.webgl.composer.enabled = this.postProcessing;
	}
}
